import { render, staticRenderFns } from "./RomanianLottery.vue?vue&type=template&id=6dcc4207&scoped=true&"
import script from "./RomanianLottery.vue?vue&type=script&lang=ts&"
export * from "./RomanianLottery.vue?vue&type=script&lang=ts&"
import style0 from "./RomanianLottery.vue?vue&type=style&index=0&id=6dcc4207&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dcc4207",
  null
  
)

export default component.exports